// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__KR4iJ","mainImg":"LoadingSpinner_mainImg__iGDly","drivin":"LoadingSpinner_drivin__FDs1o","roller":"LoadingSpinner_roller__nXV-i"};